import React from 'react';
import { motion } from 'framer-motion';
import ProjectItem from '../ProjectItem/ProjectItem';
import "./ProjectStyles.scss"

const Projects = () => {
    const project = {
        harmonic: {
            name: "Harmonic",
            description: "Virtual Machine & Parser",
            p1: "An individual effort of creating a byte-code virtual machine that simulates the inner-workings of a real computer. The includes the ability to write, parse and compile custom assembly code along with walking through its execution.",
            p2: "Harmonic was designed to help me better understand the lower levels of computer architecture and I hope that it can help others soon too. My next step is adding in high-level language support.",
            tech: ["TypeScript (ES6)", "React", "Redux", "Mocha / Chai Tests", "HTML", "SCSS", "ChakraUI", "Monaco / Monarch", "Prism"],
            repo: "https://github.com/Yyassin/HarmonicVM",
            live: "https://yyassin.github.io/HarmonicVM/"
        },
        rplss : {
            name: "RPLSS",
            description: "Deep-learning AI-based Game",
            p1: "A group development of a full stack application for Hack the North 2021. Inspired by the COVID-19 lockdown, RPLSS allows user to play rock, paper, scissors, lizard, spock in an online but face-to-face environment where they may interact with gestures - maintaining the game's integrity.",
            p2: "RPLSS leverages deep-learning to authenticate users with facial recognition and then recognize their desired play by the shape of their hand. The game is played against a Markov-based computer AI.",
            tech: ["JavaScript (ES6)", "React", "Context API", "Python", "Flask", "OpenCV", "TensorFlow", "WebSockets", "CockroachDB", "Multithreading"],
            repo: "https://github.com/Yyassin/Deep-Learning-Rock-Paper-Scissors",
            live: "https://www.youtube.com/watch?v=hRXGD4qBmT8&ab_channel=Rajessen"
        },
        illumi : {
            name: "Illumi",
            description: "Communication & Collaboration Platform",
            p1: "A paired development of a full stack desktop application utilising a MERN stack. Pushed by the movement to online, Illumi was designed to help simplify online-learning and course delivery through digital means.",
            p2: "The app supports course integration into servers that students enroll in. Within servers, students are able to interact with classmates through room-based messaging and real-time whiteboarding. Native window and notification support was also achieved using Electron.",
            tech: ["JavaScript (ES6)", "Electron", "React", "Redux", "GraphQL", "Apollo", "MongoDB", "Node.js / Express", "WebSockets", "JSON Web Token (Auth)", "Azure"],
            repo: "https://github.com/Yyassin/illumi",
        },
        algorithm_vis : {
            name: "AlgoVis",
            description: "Sorting and Pathfinding Visualizations",
            p1: "An individual development of an algorithm visualizer app to demonstrate select sorting, pathfinding and maze generation algorithms in action.",
            p2: "AlgoVis implements recursive divison to generates mazes along with the following pathfinding algorithms: Astar, Djikstra, Greedy, Swarm, BFS, Bidirectional BFS and DFS. The supported sorting algorithms are: Bubble, Insertion, Selection, Quick, Heap and Merge Sort.",
            tech: ["TypeScript (ES6)", "React", "Tailwind CSS"],
            repoSort: "https://github.com/Yyassin/SortingVisualizer",
            liveSort: "https://yyassin.github.io/SortingVisualizer/",
            repoPath: "https://github.com/Yyassin/PathfindingVisualizer",
            livePath: "https://yyassin.github.io/PathfindingVisualizer/"
        },
        stockpreme : {
            name: "Stockpreme",
            description: "Stocks & Financing App",
            p1: "A group development of a Java FX - based application consuming webscraped Yahoo Finance data. Stockpreme aims to bridge together all a user's financial operations, such as investing and banking, into a single application",
            p2: "The application's interface allows users to search for and invest in stocks, along with standard ATM operations such as deposits an withdrawals. All account information is persisted with a file-based database solution and user-authentication.",
            tech: ["Java FX", "WebScraping"],
            repo: "https://github.com/Yyassin/Stockpreme",
        },
        ecri : {
            name: "Ecri",
            description: "Realtime Collaborative Notetaker",
            p1: "A paired production of a full stack mobile app utilising a MERN stack to allow users to share notes. Ecri is being developped with two-factor user authentication, CRUD operations and implements a Node backend with React Native frontend.",
            p2: "Users are able to create, tag and collaborate on notes in real-time. Ecri also supports individual editing offline, with changes being persisted and pushed when reconnected to a network. The app is still in the middle stages of development but is coming along nicely. ",
            tech: ["TypeScript (ES6)", "React Native", "Axios", "MongoDB", "SQLite", "Node.js / Express", "WebSockets", "JSON Web Token (Auth)", "Nodemailer"],
        }
    }

    const animateInitial = {
        opacity: 0,
        y: 40,
    };
    const animateFinal = {
        opacity: 1,
        y: 0,
    };

    return (
        <div className="projects">
            <div className="content">
            <motion.div 
                    className="main-text"
                    initial={animateInitial}
                    animate={animateFinal}
                    transition={{duration: 1.5, delay: 1.4, ease: "easeOut"}}
                >
                <h1>
                    Select Works
                </h1>
                </ motion.div>
                <div className="row">
                    <ProjectItem proj={project.rplss}/>
                    <ProjectItem proj={project.harmonic}/>
                </div>
                <div className="row">
                    <ProjectItem proj={project.illumi}/>
                    <ProjectItem proj={project.algorithm_vis}/>
                </div>
                <div className="row">
                    <ProjectItem proj={project.stockpreme}/>
                    <ProjectItem proj={project.ecri}/>
                </div>
            </div>
        </div>
    );
};

export default Projects;